import $ from 'jquery';
import services from "./services";

export default class PrintSvc {

  setServiceRootPath(rootPath) {
    this.rootPath = rootPath + "/printSvc";
  }

  print(options) {
    const self = this;
    return new Promise(
        function (resolve, reject) {
          services.auth.getCurrentUserIdToken().then(function (token) {
            $.ajax({
              url: self.rootPath,
              contentType: 'application/json',
              type: 'POST',
              cache: false,
              headers: {
                "Authorization": 'Bearer ' + token
              },
              timeout: 20000,
              data: JSON.stringify(options),
              success: function (data) {
                resolve(data ? data.blob : '');
              },
              error: function (xhr) {
                reject(xhr);
              },
            });
          }, reject)
        }
    );
  }
}
